export function convertToTitleCase(string: string | null | undefined) {
    if (!string) {
        return ''
    }

    return string.replace(/\w\S*/g, function (text) {
        return text.charAt(0).toUpperCase() + text.substring(1)
    })
}

export function convertToTitleCaseHandleSpecialCharacters(string: string) {
    if (!string) {
        return ''
    }

    // looks at all characters that aren't white spaces
    return string.replace(/\S*/g, function (text) {
        // if the first character is not a letter, skip the word
        if (!text.charAt(0).match(/[a-z]/i)) {
            return text
        }
        return text.charAt(0).toUpperCase() + text.substring(1)
    })
}
